export { default } from './ViewDevicePage';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/ViewDevicePage/index.ts